import React from "react"

const MultiSelectorOption = ({ className, onClick, value}) => {
    return <div className={className} onClick={() => onClick(value)}>{value.label}</div>
}

export default MultiSelectorOption